import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdministratorService } from '../../../services/administrator.service';
import { LoaderComponent } from '../../loader/loader.component';

@Component({
  selector: 'app-create-roles',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-roles.component.html',
  styleUrl: './create-roles.component.scss'
})
export class CreateRolesComponent implements OnInit {

  constructor(private messageService: MessageService, private router: Router, private administratorService: AdministratorService, private route: ActivatedRoute) { }

  submitted: boolean = false;
  editRole: boolean = false;
  RoleId: number = 0;
  editRoleData: any;
  loader: boolean = false;

  createRoleForm = new FormGroup({
    RoleName: new FormControl('', Validators.required),
    RoleDescription: new FormControl('', Validators.required),
    createdby: new FormControl(''),
    isActive: new FormControl(true, Validators.requiredTrue),
  });


  ngOnInit(): void {
    document.title = 'Create Role';
    this.createRoleForm.controls.createdby.setValue(localStorage.getItem('username'));
    this.EditRecord();
  }


  get formControls() {
    return this.createRoleForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createRoleForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }


  createRole(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    this.loader = true;
    this.administratorService.createRole(this.createRoleForm.value).subscribe({
      next: data => {
        // console.log(data);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Role Created Successfully.' });
        // this.createRoleForm.controls.RoleName.reset();
        // this.createRoleForm.controls.RoleDescription.reset()
        this.loader = false;
        setTimeout(() => {
          this.router.navigate(['/home/listRoles']);
        }, 1000);
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })

  }

  Cancel() {
    this.router.navigate(['/home/listRoles']);
  }

  EditRecord() {
    this.route.queryParams.subscribe(params => {
      try {
        this.editRoleData = JSON.parse(params['roleData']);
        // console.log('Params:', params);
        // console.log('EditRoleData:', this.editRoleData);

        if (this.editRoleData) {
          this.editRole = true;
          this.createRoleForm.controls.RoleName.setValue(this.editRoleData.roleName);
          this.createRoleForm.controls.RoleDescription.setValue(this.editRoleData.roleDescription);
          this.createRoleForm.controls.isActive.setValue(this.editRoleData.isActive);
          this.RoleId = this.editRoleData.roleId;
        }
      } catch (error) {
        // console.error('Error parsing roleData:', params['roleData']);
        // console.error('Error details:', error);
      }
    });
  }


  updateRole() {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    const data = {
      RoleId: this.RoleId,
      RoleName: this.createRoleForm.controls.RoleName.value,
      RoleDescription: this.createRoleForm.controls.RoleDescription.value,
      UpdatedBy: this.createRoleForm.controls.createdby.value,
      isActive: this.createRoleForm.controls.isActive.value
    };
    this.loader = true;
    this.administratorService.updateRole(data).subscribe(
      (data: any) => {
        if (data) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          this.loader = false;
          setTimeout(() => {
            this.router.navigate(['/home/listRoles']);
          }, 1000);
        } else {
          console.log(data);
          this.loader = false;
        }
      },
      (error: any) => {
        console.error('An error occurred while updating the role:', error);
        this.loader = false;
      }
    );
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }

}
